export const DOTS = 'DOTS' as const;
